import { render, staticRenderFns } from "./InviteFriendsUrl.vue?vue&type=template&id=065e1c0e&"
import script from "./InviteFriendsUrl.vue?vue&type=script&lang=js&"
export * from "./InviteFriendsUrl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports